import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { BetNotificationWr, loadingStore, roundInfoStore, SlowConnectionWr, useTranslation } from '@pascal/pascal-core';

import Timer from '../common/timer';
import { WinPopUp } from '../common';
import { doBetStore } from '../../store';
import { gameDrawer } from '../../gameDrawer';
import { globalTranslationKeys } from '../../enums';
import { LastResultsCont } from '../common/lastResults';
import BetPlaceInfo, { minOdd } from '../../components/common/betPlaceInfo';
import { getScreenResolution } from '../../core/helpers/getScreenResolution';
import { BetSection, BetTypeSectionBottomRangeAndBtn } from '../../components/common';

const MobileGame = observer(() => {
  const t = useTranslation();
  const game = useRef(null);
  const chestContainer = useRef(null);
  const { winAmount } = doBetStore;
  const { roundId } = roundInfoStore;
  const { activeFreeBet } = freeBetStore;
  const [style, setStyle] = useState({});

  useEffect(() => {
    setStyle(getScreenResolution());
    window.addEventListener('resize', () => {
      setStyle(getScreenResolution());
    });
  }, [chestContainer]);

  useEffect(() => {
    gameDrawer.execute(game.current).then(() => {
      loadingStore.updateLoading({ isPixiLoaded: true });
    });
  }, []);

  return (
    <>
      <BetNotificationWr translationDynamicValues={{ value: `x${activeFreeBet.id ? activeFreeBet.minOdd : minOdd}` }} />
      <SlowConnectionWr />
      <div ref={game} className='game-container' style={style.canvasContainer} />
      <div className='m-game-center-wrapper'>
        <div className='top-m-game-center-wrapper' ref={chestContainer}>
          <Timer />
          <LastResultsCont />
          <div className='game-round-id-wrp'>
            <div className='game-round-id'>
              <p className='g-r-p-id round'>{t(globalTranslationKeys.RoundId)}:</p>
              <p className='g-r-p-id'>{roundId}</p>
            </div>
          </div>
        </div>
        <div className='bottom-m-game-center-wrapper'>
          {winAmount ? <WinPopUp winAmount={winAmount} t={t} /> : <></>}
          <div className='w-md-bet-wrapper'>
            <BetPlaceInfo />
            <div className='w-md-bet-panel'>
              <BetTypeSectionBottomRangeAndBtn />
              <BetSection />
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default MobileGame;
